import { render, staticRenderFns } from "./AutomaticCommentaryForm.vue?vue&type=template&id=4aeabf99&scoped=true"
import script from "./AutomaticCommentaryForm.vue?vue&type=script&lang=js"
export * from "./AutomaticCommentaryForm.vue?vue&type=script&lang=js"
import style0 from "./AutomaticCommentaryForm.vue?vue&type=style&index=0&id=4aeabf99&prod&lang=css"
import style1 from "./AutomaticCommentaryForm.vue?vue&type=style&index=1&id=4aeabf99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeabf99",
  null
  
)

export default component.exports